import { X } from "lucide-react";

export const GlassCard = ({ className = "", children, ...p }) => (
  <div className={`glass rounded-lg ${className}`} {...p}>{children}</div>
);

const QUALITY_STYLES = {
  CAM: "bg-[rgba(255,0,85,0.15)] border-[rgba(255,0,85,0.5)] text-[#ff4d8d]",
  TS: "bg-[rgba(255,0,85,0.15)] border-[rgba(255,0,85,0.5)] text-[#ff4d8d]",
  SD: "bg-slate-500/15 border-slate-500/50 text-slate-300",
  HD: "bg-[rgba(245,158,11,0.15)] border-[rgba(245,158,11,0.5)] text-amber-400",
  FHD: "bg-[rgba(0,240,255,0.12)] border-[rgba(0,240,255,0.5)] text-cyan-300",
  UHD4K: "bg-[rgba(157,78,221,0.15)] border-[rgba(157,78,221,0.5)] text-purple-300",
};

export const QualityBadge = ({ quality, testid }) => (
  <span data-testid={testid} className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[10px] font-mono2 font-semibold tracking-wider ${QUALITY_STYLES[quality] || QUALITY_STYLES.SD}`}>
    {quality}
    {(quality === "CAM" || quality === "TS") && " · AUTO-REPLACE"}
  </span>
);

const VERSION_STYLES = {
  dublado: "bg-emerald-500/15 border-emerald-500/50 text-emerald-300",
  legendado: "bg-purple-500/15 border-purple-500/50 text-purple-300",
  dual: "bg-cyan-500/15 border-cyan-500/50 text-cyan-300",
  nacional: "bg-amber-500/15 border-amber-500/50 text-amber-300",
};

export const VersionBadge = ({ version, testid }) => (
  <span data-testid={testid} className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[10px] font-mono2 font-semibold tracking-wider uppercase ${VERSION_STYLES[version] || VERSION_STYLES.dual}`}>
    {version}
  </span>
);

export const PageHeader = ({ eyebrow, title, subtitle, children }) => (
  <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 anim-fade-up">
    <div>
      {eyebrow && <p className="text-xs font-mono2 uppercase tracking-[0.3em] text-amber-500/90 mb-2">{eyebrow}</p>}
      <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-white">{title}</h1>
      {subtitle && <p className="text-sm text-slate-400 mt-2 max-w-2xl">{subtitle}</p>}
    </div>
    {children && <div className="flex items-center gap-3">{children}</div>}
  </div>
);

export const Modal = ({ open, onClose, title, children, testid }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid={testid}>
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative glass rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto p-6 anim-fade-up">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-display text-lg font-semibold text-white">{title}</h3>
          <button data-testid={`${testid}-close`} onClick={onClose} className="p-1.5 rounded-lg btn-ghost-dark text-slate-400 hover:text-white">
            <X size={18} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

export const EmptyState = ({ icon: Icon, title, subtitle, testid }) => (
  <div data-testid={testid} className="glass rounded-lg p-10 flex flex-col items-center justify-center text-center">
    <div className="w-14 h-14 rounded-lg bg-amber-500/10 border border-amber-500/25 flex items-center justify-center mb-4">
      <Icon size={26} className="text-amber-400" />
    </div>
    <p className="font-display text-white font-semibold">{title}</p>
    {subtitle && <p className="text-sm text-slate-400 mt-1 max-w-sm">{subtitle}</p>}
  </div>
);

export const Spinner = () => <div className="spinner" data-testid="loading-spinner" />;
